{
  "version": 1,
  "asset_id": "4bd37028-a5f3-4be5-b4bd-1ce37ac70a46",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/4bd37028-a5f3-4be5-b4bd-1ce37ac70a46/publications-thumb.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/4bd37028-a5f3-4be5-b4bd-1ce37ac70a46/publications-thumb.webp",
  "original_filename": "publications-thumb.webp",
  "size": 1736,
  "content_type": "image/webp",
  "created_at": "2026-07-28T02:25:17Z"
}
